import type React from 'react';
import { useIntl } from 'react-intl';

import { Column } from '@xing-com/xing-grid';

import { LOGIN_LINK } from './constants';
import {
  StyledGrid,
  StyledButton,
  StyledHeadline,
  StyledSecondaryHeadline,
  IllustrationColumn,
  ContentRow,
  StyledIllustrationPremiumSpotGroup,
} from './page-header.styles';

type PageHeaderProps = {
  asSecondaryHeadline?: boolean;
};

export const PageHeader: React.FC<PageHeaderProps> = ({
  asSecondaryHeadline,
}) => {
  const { formatMessage } = useIntl();

  const HeaderComponent = asSecondaryHeadline
    ? StyledSecondaryHeadline
    : StyledHeadline;

  return (
    <StyledGrid>
      <ContentRow>
        <Column size={9} sizeTiny={12}>
          <HeaderComponent>
            {formatMessage({ id: 'PD_100_HEADING' })}
          </HeaderComponent>
          <StyledButton variant="secondary" size="medium" href={LOGIN_LINK}>
            {formatMessage({ id: 'PD_LOGIN_TO_SEARCH' })}
          </StyledButton>
        </Column>
        <IllustrationColumn size={3} sizeTiny={12}>
          <StyledIllustrationPremiumSpotGroup />
        </IllustrationColumn>
      </ContentRow>
    </StyledGrid>
  );
};
